import React, { useState, useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux'

import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'

import Button from '@material-ui/core/Button'
import Fab from '@material-ui/core/Fab'
import Avatar from '@material-ui/core/Avatar'
import Chip from '@material-ui/core/Chip'
import Tooltip from '@material-ui/core/Tooltip'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Table from '@material-ui/core/Table'

import { ThemeProvider } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Fade from '@material-ui/core/Fade'

import DeleteIcon from '@material-ui/icons/Delete'
import AddIcon from '@material-ui/icons/Add'
import DoneIcon from '@material-ui/icons/Done'
import CloseIcon from '@material-ui/icons/Close'
import InfoIcon from '@material-ui/icons/Info'

import { updateWord, getWordVault, deleteWord } from '../../../../redux/actions'

import { SliderTheme } from '../../../../utils'

import { NotificationToast, BaseToast } from '../../tools/Toast'
import ConfirmToast from '../../tools/ConfirmToast'

// import Locales from '../locales.json'

/**
 * Returns word vault editor form
 */
const WordVaultEdit = ({
  onBackTrack, selectedKey, getAvatarBackground,
  StyledSwitch, StyledCheckBox, CustomSlider, useStyles
}) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  // const getLanguages = () => {
  //   const languages = []
  //   for (const [key, value] of Object.entries(Locales)) {
  //     languages.push({ value: key, language: value })
  //   }

  //   return languages
  // }

  // const languages = [{ value: 'us-en', language: 'ENGLISH' }, { value: 'es-mx', language: 'SPANISH' }]
  // const languages = getLanguages()

  const marks = [
    { value: 20, label: '' },
    { value: 40, label: '' },
    { value: 60, label: '' },
    { value: 80, label: '' },
    { value: 100, label: '' }
  ]

  const [exceptions, setExceptions] = useState([])
  const [newExceptions, setNewExceptions] = useState([])
  const [deleteExceptions, setDeleteExceptions] = useState([])

  const categories = useSelector(state => state.words.categories)
  const wordDetails = useSelector(state => state.words.wordDetails)

  const [categoriesInfo, setCategoriesInfo] = useState([])
  const [word, setWord] = useState({
    phrase: '',
    autoIgnore: 0,
    categoryID: '',
    embedded: 0,
    excluded: 0,
    language: '',
    severity: 1,
    wordDefinition: '',
    keyboard: 0,
    application: 0
  })

  const [enabled, setEnabled] = useState(false)
  const [autoIgnore, setAutoIgnore] = useState(false)
  const [embedded, setEmbedded] = useState(false)
  const [keyboard, setKeyboard] = useState(false)
  const [application, setApplication] = useState(false)
  // const [emailReport, setEmailReport] = useState(false)

  const [openInfo, setOpenInfo] = useState(false)

  const [wordID, setWordID] = useState('')
  const [phrase, setPhrase] = useState('')
  const [category, setCategory] = useState('')
  const [language, setLanguage] = useState('')
  const [wordDefinition, setWordDefinition] = useState('')

  const [severity, setSeverity] = useState(1)
  const [keySeverity, setKeySeverity] = useState(1)

  const [adding, setAdding] = useState(false)
  const [term, setTerm] = useState('')
  const [placement, setPlacement] = useState('ANY')
  const placements = ['BEFORE', 'AFTER', 'ANY']

  useEffect(() => {
    if (categories) {
      const mappedCategories = []
      categories.forEach(category => {
        mappedCategories.push(category)
      })
      setCategoriesInfo(mappedCategories)
    }
  }, [setCategoriesInfo, categories])

  useEffect(() => {
    const { word, exclusions } = wordDetails
    if (word) {
      setPhrase(word.phrase)
      setSeverity(word.severity)
      setKeySeverity(word.severity >= 50 ? 100 : word.severity * 2)
      setLanguage(word.language)
      setWordDefinition(word.wordDefinition)
      setEnabled(word.excluded === 0)
      setAutoIgnore(word.autoIgnore === 1)
      setEmbedded(word.embedded === 1)
      setCategory(word.categoryID)
      setWordID(word.wordID)
      setKeyboard(word.keyboard === 1)
      setApplication(word.application === 1)
      setWord(word)
    }
    if (exclusions) {
      setExceptions(exclusions)
    }
  }, [wordDetails])

  const handleSave = () => {
    if (adding) {
      NotificationToast(false, 'Save new exceptions!', true)
    } else {
      const wordInfo = {
        categoryID: category,
        phrase,
        severity,
        wordDefinition,
        embedded: embedded ? 1 : 0,
        excluded: enabled === true ? 0 : 1,
        autoIgnore: autoIgnore ? 1 : 0,
        keyboard: keyboard ? 1 : 0,
        application: application ? 1 : 0,
        language,
        newExclusions: [...newExceptions],
        deleteExclusions: [...deleteExceptions]
      }
      dispatch(updateWord(wordInfo, wordID, selectedKey, fireUpdateSuccess, fireUpdateFailure))
    }
  }

  const handleAddException = () => {
    setAdding(true)
  }

  const fireUpdateSuccess = () => {
    dispatch(getWordVault(selectedKey))
    NotificationToast(false, 'Successfully updated word!')
    setWordID('')
    setPhrase('')
    setCategory('')
    setLanguage('')
    setWordDefinition('')
    setTerm('')

    setSeverity(1)

    setAdding(false)
    setEnabled(false)
    setEmbedded(false)
    setAutoIgnore(false)
    setKeyboard(false)
    setApplication(false)

    setExceptions([])
    setNewExceptions([])
    setDeleteExceptions([])

    onBackTrack()
  }

  const fireUpdateFailure = () => {
    NotificationToast(true, 'Failed to update word!')
  }

  const handleDoneException = () => {
    if (term === '') {
      NotificationToast(false, 'Exception must have a term!', true)
    } else {
      const tempExceptions = [...exceptions]
      const tempNewExceptions = [...newExceptions]
      const newExpRendered = {
        exclusionPhrase: term.toUpperCase(),
        excludeBefore: placement === 'BEFORE' ? 1 : 0,
        excludeAfter: placement === 'AFTER' ? 1 : 0,
        excludeAny: placement === 'ANY' ? 1 : 0
      }
      tempExceptions.push(newExpRendered)
      tempNewExceptions.push(newExpRendered)
      setExceptions(tempExceptions)
      setNewExceptions(tempNewExceptions)
      setAdding(false)
      setTerm('')
      setPlacement('ANY')
    }
  }

  const handleExpDelete = (exception) => {
    const { exclusionID } = exception
    if (exclusionID) {
      const tempExpDelete = [...deleteExceptions]
      tempExpDelete.push({ exclusionID })
      setDeleteExceptions(tempExpDelete)
      const expIndex = exceptions.findIndex((exp) => {
        return exp === exception
      })
      if (expIndex !== -1) {
        const tempExceptions = [...exceptions]
        tempExceptions.splice(expIndex, 1)
        setExceptions(tempExceptions)
      }
    } else {
      const expIndex = exceptions.findIndex((exp) => {
        return exp === exception
      })
      if (expIndex !== -1) {
        const tempExceptions = [...exceptions]
        tempExceptions.splice(expIndex, 1)
        setExceptions(tempExceptions)
      }

      const newExpIndex = newExceptions.findIndex((exp) => {
        return exp === exception
      })

      if (newExpIndex !== -1) {
        const tempNewExceptions = [...newExceptions]
        tempNewExceptions.splice(newExpIndex, 1)
        setNewExceptions(tempNewExceptions)
      }
    }
  }

  const handleDiscardException = () => {
    setTerm('')
    setPlacement('ANY')
    setAdding(false)
  }

  const handleDelete = async () => {
    const confirm = await ConfirmToast({ msg: 'Are you sure you want to delete this word?', txt: '' })
    if (confirm) {
      dispatch(deleteWord(wordID, selectedKey, fireDeleteSuccess, fireDeleteFailure))
    }
  }

  const fireDeleteSuccess = () => {
    dispatch(getWordVault(selectedKey))
    NotificationToast(false, 'Successfully deleted word!')
    setWordID('')
    setPhrase('')
    setCategory('')
    setLanguage('')
    setWordDefinition('')
    setTerm('')

    setSeverity(1)

    setAdding(false)
    setEnabled(false)
    setEmbedded(false)
    setAutoIgnore(false)
    setKeyboard(false)
    setApplication(false)

    setExceptions([])
    setNewExceptions([])
    setDeleteExceptions([])

    onBackTrack()
  }

  const fireDeleteFailure = () => {
    NotificationToast(true, 'Failed to delete word!')
  }

  const handleSliderChange = (e, newVal) => {
    setSeverity(newVal)
    if (newVal * 2 < 100) {
      setKeySeverity(newVal * 2)
    } else {
      setKeySeverity(100)
    }

    if (newVal > 50) {
      if (!openInfo) {
        setOpenInfo(true)
      }
    } else {
      if (openInfo) {
        setOpenInfo(false)
      }
    }
  }

  const toggleKeyboard = () => {
    if (application === false || 0) {
      BaseToast('info', 'Phrase must have at least one source selected.')
    } else {
      setKeyboard(!keyboard)
    }
  }

  const toggleApplication = () => {
    if (keyboard === false || 0) {
      BaseToast('info', 'Phrase must have at least one source selected.')
    } else {
      setApplication(!application)
    }
  }

  const handleBack = async () => {
    if (
      (word.phrase !== phrase) || (word.categoryID !== category) || (word.embedded !== (embedded ? 1 : 0)) ||
      (word.excluded !== (enabled ? 0 : 1)) || (word.language !== language) || (word.severity !== severity) ||
      (word.keyboard !== (keyboard ? 1 : 0)) || (word.application !== (application ? 1 : 0)) ||
      (word.wordDefinition !== wordDefinition) || (newExceptions.length !== 0) || (deleteExceptions.length !== 0)
    ) {
      const changeStat = await ConfirmToast({ msg: 'Are you sure you want to go back?', txt: 'This will reset any changes made.' })
      if (changeStat === true) {
        onBackTrack()
      }
    } else {
      onBackTrack()
    }
  }

  const enableSave = (
    (word.phrase !== phrase) || (word.categoryID !== category) || (word.embedded !== (embedded ? 1 : 0)) ||
    (word.excluded !== (enabled ? 0 : 1)) || (word.language !== language) || (word.severity !== severity) ||
    (word.keyboard !== (keyboard ? 1 : 0)) || (word.application !== (application ? 1 : 0)) || (word.autoIgnore !== (autoIgnore ? 1 : 0)) ||
    (word.wordDefinition !== wordDefinition) || (newExceptions.length !== 0) || (deleteExceptions.length !== 0)
  )

  return (
    <>
      <Paper elevation={2} className={classes.editPaper}>
        <Grid container direction='column' justify='center' className='w-100 mx-auto'>

          <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto mt-2 mb-2 px-3'>
            <Grid item xs={9}>
              <Chip
                label={
                  <>
                    <Grid container direction='row'>
                      <Grid item xs={8} container alignContent='center'>
                        <Typography variant='h6' component='h6' className='font-weight-bold text-break text-wrap w-100'>{phrase}</Typography>
                      </Grid>
                      <Grid item xs={4} container justify='flex-end'>
                        <Avatar variant='circle' className={`${classes.severityAvatar} ${getAvatarBackground(Math.ceil(severity / 2))}`}>
                          <Grid container direction='column' alignItems='center' justify='center'>
                            <Grid item>
                              <Typography variant='h5' component='h5' align='center' className='font-weight-bold'>
                                {severity}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Avatar>
                      </Grid>
                    </Grid>
                  </>
                }
                className={`${classes.phraseChip}`}
                classes={{
                  label: classes.label
                }}
              />
            </Grid>

            <Grid item xs={2} container alignContent='center'>
              <Typography
                variant='body1'
                component='label'
                className='font-weight-bold'
              >
                Phrase
              </Typography>
            </Grid>
          </Grid>

          {/* <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto my-2 px-3'>

            <Grid item xs={9} container direction='row' style={{ margin: 'auto' }}>
              <Chip
                label={
                  <>
                    <Grid container direction='row'>
                      <Grid item xs={8} container alignContent='center'>
                        <Typography variant='h6' component='h6' className='font-weight-bold text-break text-wrap w-100'>{phrase}</Typography>
                      </Grid>
                      <Grid item xs={4} container justify='flex-end'>
                        <Avatar variant='circle' className={`${classes.severityAvatar} ${getAvatarBackground(Math.ceil(severity / 2))}`}>
                          <Grid container direction='column' alignItems='center' justify='center'>
                            <Grid item>
                              <Typography variant='h5' component='h5' align='center' className='font-weight-bold'>
                                {severity}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Avatar>
                      </Grid>
                    </Grid>
                  </>
                }
                className={`${classes.phraseChip}`}
                classes={{
                  label: classes.label
                }}
              />
            </Grid>

            <Grid item xs={2} container alignContent='center'>
              <Typography
                variant='body1'
                component='label'
                className='font-weight-bold'
              >
                Phrase
              </Typography>
            </Grid>
          </Grid> */}

          <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto px-3'>
            <Grid item xs={9}>
              <FormControl className='w-100'>
                <InputLabel className='pl-3 py-1'>Category</InputLabel>
                <Select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  variant='outlined'
                >
                  {categoriesInfo.map((category) => {
                    const { categoryID, categoryName } = category
                    return (
                      <MenuItem value={categoryID} key={`category-${categoryID}`}>
                        {categoryName}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={3} container alignContent='center' justify='flex-start'>
              <Typography
                variant='body1'
                component='label'
                className='font-weight-bold'
              >
                Category
              </Typography>
            </Grid>
          </Grid>

          <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto my-2 px-3'>
            <Grid item xs={9}>
              <FormControl className='w-100'>
                <InputLabel className='pl-3 pt-1 pb-1'>Language</InputLabel>
                <Select
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                  variant='outlined'
                >
                  <MenuItem value='en-us'>
                    English
                  </MenuItem>
                  <MenuItem value='es-es'>
                    Spanish
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={3} container alignContent='center' justify='flex-start'>
              <Typography
                variant='body1'
                component='label'
                className='font-weight-bold'
              >
                Language
              </Typography>
            </Grid>
          </Grid>

          <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto px-3'>
            <Grid item xs={9}>
              <FormControl className='w-100'>
                <TextField
                  placeholder='Definition...'
                  multiline
                  rows={3}
                  variant='outlined'
                  value={wordDefinition}
                  onChange={(e) => setWordDefinition(e.target.value)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={3} container alignContent='center' justify='flex-start'>
              <Typography
                variant='body1'
                component='label'
                className='font-weight-bold'
              >
                Definition
              </Typography>
            </Grid>
          </Grid>

          <ThemeProvider theme={SliderTheme(severity)}>

            <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto mt-5 mb-1 px-4'>
              <Grid item xs={9}>
                <CustomSlider
                  value={parseInt(severity, 10)}
                  onChange={handleSliderChange}
                  valueLabelDisplay='on'
                  aria-labelledby='app-severity-slider'
                  min={1}
                  max={100}
                  marks={marks}
                />
              </Grid>

              <Grid item xs={3} container justify='flex-start'>
                <Typography
                  variant='body1'
                  component='label'
                  className='font-weight-bold'
                >
                  Application Severity
                </Typography>
              </Grid>
            </Grid>

            <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto my-2 px-3'>
              <Grid item xs={9}>
                <ThemeProvider theme={SliderTheme(keySeverity)}>
                  <Tooltip
                    title={<Typography className='p-2'><InfoIcon /> Keyboard Severity maxed out</Typography>}
                    open={openInfo}
                    onClose={() => setOpenInfo(false)}
                    placement='left'
                    TransitionComponent={Fade}
                    TransitionProps={{ timeout: 600 }}
                    arrow
                  >
                    <CustomSlider
                      value={parseInt(keySeverity, 10)}
                      // onChange={(e, newVal) => setKeySeverity(newVal)}
                      valueLabelDisplay='on'
                      aria-labelledby='key-severity-slider'
                      min={1}
                      max={100}
                      marks={marks}
                    />
                  </Tooltip>
                </ThemeProvider>
              </Grid>

              <Grid item xs={3} container justify='flex-start'>
                <Typography
                  variant='body1'
                  component='label'
                  className='font-weight-bold text-wrap'
                >
                  Keyboard Severity
                </Typography>
              </Grid>
            </Grid>

          </ThemeProvider>

          <Grid item container direction='row' justify='space-around' spacing={3} className='w-100 mt-1 mx-auto px-3'>
            <Grid item xs={4} container justify='center' direction='column'>
              <Grid item container justify='center'>
                <Typography
                  variant='body1'
                  component='label'
                  className='font-weight-bold'
                >
                  Phrase Enabled
                </Typography>
              </Grid>

              <Grid item container justify='center'>
                <FormControlLabel
                  label={enabled ? 'Enabled' : 'Disabled'}
                  control={
                    <StyledSwitch
                      checked={enabled}
                      onChange={() => setEnabled(!enabled)}
                    />
                  }
                  labelPlacement='end'
                />
              </Grid>
            </Grid>

            <Grid item xs={4} container justify='center' direction='column'>
              <Grid item container justify='center'>
                <Typography
                  variant='body1'
                  component='label'
                  className='font-weight-bold'
                >
                  Auto 'Not A Problem'
                </Typography>
              </Grid>
              <Grid item container justify='center'>
                <FormControlLabel
                  label={autoIgnore ? 'Enabled' : 'Disabled'}
                  control={
                    <StyledSwitch
                      checked={autoIgnore}
                      onChange={() => setAutoIgnore(!autoIgnore)}
                    />
                  }
                  labelPlacement='end'
                />
              </Grid>
            </Grid>

            {/* <Grid item xs={4} container justify='center' direction='column'>
              <Grid item container justify='center'>
                <Typography
                  variant='body1'
                  component='label'
                  className='font-weight-bold'
                >
                  Email Report
                </Typography>
              </Grid>
              <Grid item container justify='center'>
                <FormControlLabel
                  label={emailReport ? 'Enabled' : 'Disabled'}
                  control={
                    <StyledSwitch
                      checked={emailReport}
                      onClick={(e) => { e.preventDefault(); setEmailReport(!emailReport) }}
                    />
                  }
                  labelPlacement='end'
                />
              </Grid>
            </Grid> */}
          </Grid>

          <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto px-3'>
            <Grid item xs={6} container justify='center' direction='column' alignItems='center'>
              <Grid item container justify='center' className='mt-auto'>
                <Typography
                  variant='body1'
                  component='label'
                  className='font-weight-bold'
                >
                  Detect Embedded
                </Typography>
              </Grid>

              <Grid item container justify='center'>
                <FormControlLabel
                  label={embedded ? 'Enabled' : 'Disabled'}
                  control={
                    <StyledSwitch
                      checked={embedded}
                      onChange={() => setEmbedded(!embedded)}
                    />
                  }
                  labelPlacement='end'
                />
              </Grid>
            </Grid>

            <Grid item xs={6} container justify='center' direction='column'>
              <Grid item container justify='center' direction='row'>
                <FormControlLabel
                  value={keyboard}
                  control={
                    <StyledCheckBox
                      checked={keyboard}
                      onChange={() => toggleKeyboard(!keyboard)}
                    />
                  }
                  label={<span className='font-weight-bold'>Keyboard</span>}
                  labelPlacement='start'
                  className='m-0 font-weight-bold'
                />
              </Grid>

              <Grid item container justify='center' direction='row'>
                <FormControlLabel
                  value={application}
                  control={
                    <StyledCheckBox
                      checked={application}
                      onChange={() => toggleApplication(!application)}
                    />
                  }
                  label={<span className='font-weight-bold'>Application</span>}
                  labelPlacement='start'
                  className='m-0'
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid container item direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto my-2 px-3'>
            <Grid item xs={9}>
              <Card>
                <TableContainer>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align='center' className={classes.tableHeader}>
                          Term
                        </TableCell>
                        <TableCell align='center' className={classes.tableHeader}>
                          Placement
                        </TableCell>
                        <TableCell colSpan={1} className={classes.tableHeader} />
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {
                        exceptions.length !== 0
                          ? exceptions.map((exception, id) => {
                            const after = exception.excludeAfter
                            const before = exception.excludeBefore
                            const any = exception.excludeAny
                            return (
                              <TableRow key={`exception-${id}`}>
                                <TableCell align='center'>
                                  {exception.exclusionPhrase}
                                </TableCell>
                                <TableCell align='center'>
                                  {after === 1 ? 'After' : before === 1 ? 'Before' : any === 1 ? 'Any' : 'N/A'}
                                </TableCell>
                                <TableCell align='center'>
                                  <Fab size='small' className={classes.deleteExp} onClick={() => handleExpDelete(exception)}>
                                    <DeleteIcon />
                                  </Fab>
                                </TableCell>
                              </TableRow>
                            )
                          }) : (
                            <TableRow>
                              <TableCell colSpan={3} align='center'>
                                <Typography className='font-weight-bold'>N/A</Typography>
                              </TableCell>
                            </TableRow>
                          )
                      }
                      {
                        adding
                          ? (
                            <TableRow>
                              <TableCell colSpan={1}>
                                <TextField
                                  value={term}
                                  onChange={(e) => setTerm(e.target.value)}
                                  variant='standard'
                                  className='w-100'
                                />
                              </TableCell>

                              <TableCell colSpan={1}>
                                <Select
                                  value={placement}
                                  onChange={(e) => setPlacement(e.target.value)}
                                  className='w-100'
                                >
                                  {placements.map((type, index) => (
                                    <MenuItem value={type} key={`placement-${index}`}>
                                      {type}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </TableCell>

                              <TableCell colSpan={1}>
                                <Fab size='small' color='primary' onClick={handleDoneException} className='mb-2'>
                                  <DoneIcon />
                                </Fab>
                                <Fab size='small' className={classes.discardBtn} onClick={handleDiscardException}>
                                  <CloseIcon />
                                </Fab>
                              </TableCell>
                            </TableRow>
                          ) : (
                            <TableRow>
                              <TableCell colSpan={3} align='center' padding='none' className='py-2'>
                                <Fab size='small' className={classes.addBtn} onClick={handleAddException}>
                                  <AddIcon />
                                </Fab>
                              </TableCell>
                            </TableRow>
                          )
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>

            <Grid item xs={3} container justify='flex-start' direction='row' alignContent='center'>
              <Typography
                variant='body1'
                component='label'
                className='font-weight-bold'
              >
                Exceptions
              </Typography>
            </Grid>
          </Grid>

          {/* <Grid container item direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto my-2 px-3'>
            <Grid item xs={12} container>
              <Grid item xs={4} container>
                <Button
                  variant='contained'
                  className={classes.deleteBtn}
                  onClick={handleDelete}
                >
                  Delete
                </Button>
              </Grid>

              <Grid item xs={4} container justify='flex-end'>
                <Button
                  variant='contained'
                  className={classes.saveBtn}
                  onClick={handleSave}
                  disabled={!enableSave}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid> */}
        </Grid>
      </Paper>
      <Grid container>
        <nav className='nav p-2 shadow sticky-nav' style={{ backgroundColor: '#FAFAFA', borderBottomLeftRadius: '4px', borderBottomRightRadius: '4px' }}>
          <Grid item xs={12} container>
            <Grid item xs={4} container>
              <Button
                variant='contained'
                className={classes.backBtn}
                onClick={(e) => { e.preventDefault(); handleBack() }}
                style={{ marginLeft: '1rem' }}
              >
                Back
              </Button>
            </Grid>

            <Grid item xs={4} container>
              <Button
                variant='contained'
                className={classes.deleteBtn}
                onClick={handleDelete}
              >
                Delete
              </Button>
            </Grid>

            <Grid item xs={4} container justify='flex-end'>
              <Button
                variant='contained'
                className={classes.saveBtn}
                onClick={handleSave}
                disabled={!enableSave}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </nav>
      </Grid>
    </>
  )
}

export default WordVaultEdit
